import { lazy, Suspense, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { LABEL } from '@veriables';
import { repostPayment } from '@reducers/storeChecks';

const RepostPaymentModal = lazy(() =>
  import('@components/storeChecks/Modals/RepostPaymentModal')
);

const useRepostPayment = ({ checkData, deviceInfo, userInfo, serverAppTheme, setErrorPopUp }) => {
  const dispatch = useDispatch();
  const [isRepost, setIsRepost] = useState(false);
  const [repostConfirmation, setRepostConfirmation] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const open = useCallback(() => setIsRepost(true), []);

  const onRepostClose = useCallback(() => {
    setIsRepost(false);
    setRepostConfirmation(false);
  }, []);

  const repostPayments = useCallback(() => {
    const payload = {
      storeId: deviceInfo?.storeId,
      deviceId: deviceInfo?.deviceId,
      employeeId: Number(userInfo?.id),
      ticketId: selectedItem?.ticketId,
      checkTicketId: selectedItem?.id,
      checkHeaderId: checkData?.id,
    };
    dispatch(repostPayment(payload))
      .then(() => {
        setRepostConfirmation(false);
        setIsRepost(false);
      })
      .catch(err => {
        setRepostConfirmation(false);
        setErrorPopUp({ res: err.message });
      });
  }, [dispatch, deviceInfo, userInfo, selectedItem, checkData, setErrorPopUp]);

  const tHead = [
    { key: 'checkbox', name: '' },
    { key: 'cardType', name: LABEL().CARD_TYPE },
    { key: 'redactedCardNumber', name: LABEL().REDACTED_CARD_NUMBER },
    { key: 'cardHolderName', name: LABEL().NAME },
    { key: 'ticketAmount', name: LABEL().TOTAL, prefix: `${LABEL().CURRENCY_SYMBOL}` },
    { key: 'tipAmount', name: LABEL().TIP, prefix: `${LABEL().CURRENCY_SYMBOL}` },
    { key: 'paymentStatus', name: LABEL().PAYMENT },
  ];

  const jsx = (
    <>
      {isRepost && (
        <Suspense fallback={null}>
          <RepostPaymentModal
            serverAppTheme={serverAppTheme}
            isOpen={isRepost}
            isRepostOpen
            onClose={onRepostClose}
            tHead={tHead}
            rowData={checkData}
            repostConfirmation={repostConfirmation}
            setRepostConfirmation={setRepostConfirmation}
            setSelectedItem={setSelectedItem}
            repostPayments={repostPayments}
            setErrorPopUp={setErrorPopUp}
          />
        </Suspense>
      )}
    </>
  );

  return { open, jsx };
};

export default useRepostPayment;
